import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { onWidthResize } from '../utils/resize.js';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class ContactStores {
    constructor(element) {
        this.element = element;
        this.init();
    }

    init = () => {
        this.initPhotoAnimation();
        this.initHeadlineAnimation();
        this.initCardAnimation();
    }

    initPhotoAnimation = () => {
        const photos = this.element.querySelectorAll('.contact-stores__photo img');

        photos.forEach((img) => {
            gsap.fromTo(
                img,
                { scale: 1.3 },
                {
                    scale: 1,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: img.closest('.contact-stores__photo'),
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    },
                }
            );
        });
    }

    initHeadlineAnimation = () => {
        const headlines = this.element.querySelectorAll('.contact-stores__headline');

        headlines.forEach((headline) => {
            const split = new SplitText(headline, { type: 'lines,words', linesClass: 'lineParent' });
            gsap.fromTo(
                split.words,
                { yPercent: 100 },
                {
                    yPercent: 0,
                    duration: 0.8,
                    stagger: { each: 0.08, ease: 'power2.out', from: 'start' },
                    ease: 'power3.out',
                    scrollTrigger: { trigger: headline, start: 'top 90%' },
                    onComplete: () => {
                        onWidthResize(() => split.revert(), { once: true });
                    },
                }
            );
        });
    }

    initCardAnimation = () => {
        const cards = this.element.querySelectorAll('.contact-stores__card');

        cards.forEach((card) => {
            const cardBg = card.querySelector('.contact-stores__card-bg');
            const text = card.querySelector('.contact-stores__card-text');
            const photo = card.querySelector('.contact-stores__card-photo');
            const img = photo?.querySelector('img');

            if (cardBg) {
                gsap.fromTo(
                    cardBg,
                    { scale: 1.6 },
                    {
                        scale: 1,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: card,
                            start: 'top bottom',
                            end: 'bottom top',
                        },
                    }
                );
            }

            if (text) {
                gsap.fromTo(
                    text,
                    { opacity: 0, y: 30 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        ease: 'power3.out',
                        scrollTrigger: { trigger: text, start: 'top 88%' },
                    }
                );
            }

            if (photo) {
                gsap.fromTo(
                    photo,
                    { clipPath: 'inset(8% round 4px)', scale: 1.08 },
                    {
                        clipPath: 'inset(0% round 4px)',
                        scale: 1,
                        duration: 1.2,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: photo,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        },
                    }
                );
            }

            if (img) {
                gsap.fromTo(
                    img,
                    { scale: 1.15 },
                    {
                        scale: 1,
                        duration: 1.4,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: photo,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        },
                    }
                );
            }
        });
    }
}
